export const IMPORT_ACCOUNT_SOURCE_MIGRATION_OPEN_MODAL = 'IMPORT_ACCOUNT_SOURCE_MIGRATION_OPEN_MODAL';
export const IMPORT_ACCOUNT_SOURCE_MIGRATION_CLOSE_MODAL = 'IMPORT_ACCOUNT_SOURCE_MIGRATION_CLOSE_MODAL';
